import { useEffect, useState } from 'react';
import { GetAppData } from 'services/data';
import DashboardSide from '../Side';
import InfoTicker from '../Ticker';
import {
  DashboardHeaderAction,
  DashboardHeaderActionIcon,
  DashboardHeaderContainer,
} from './styled';

export default function DashboardHeader({ opened, setOpened }) {
  const [values, setValues] = useState(null);
  const [loading, setLoading] = useState(true);

  const init = async () => {
    setLoading(true);
    try {
      const res = await GetAppData();
      setValues(res);
    } catch (err) {
      console.error('Erro ao carregar regras', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => init(), []);

  if (loading || !values?.pre_proposal || !values?.financing) {
    return <div>Carregando indicadores...</div>;
  }

  const appInfo = [
    { label: '', value: '' },
    { label: '', value: '' },
    { label: '', value: '' },
    { label: '', value: '' },
    { label: 'SIMULADO:', value: values?.pre_proposal.simulado },
    { label: 'PRÉ-APROVADO:', value: values?.pre_proposal.aprovado },
    { label: 'PROPOSTAS:', value: values.financing.propostas },
    { label: 'ELEGÍVEIS:', value: values.financing.elegiveis },
    { label: 'EM ANÁLISE:', value: values.financing.em_analise },
    { label: 'APROVADAS:', value: values.financing.aprovadas },
    { label: 'A PAGAR:', value: values.financing.a_pagar },
    { label: 'TOTAL:', value: values.financing.total },
    { label: 'PAGO NO MÊS:', value: values.financing.pago_mes },
  ];

  return (
    <>
      <DashboardHeaderContainer opened={opened}>
        <DashboardHeaderAction onClick={() => setOpened(!opened)}>
          <DashboardHeaderActionIcon
            src={`/icons/panel-left.svg`}
            alt="menu-icon"
          />
        </DashboardHeaderAction>
        <InfoTicker data={appInfo} />
      </DashboardHeaderContainer>
      <DashboardSide opened={opened} setOpened={setOpened} />
    </>
  );
}
